import { extendTheme } from '@chakra-ui/react';

export default extendTheme({
    components: {
        Input: {
            baseStyle: {
                field: {
                    borderColor: 'darkGrey',
                    color: 'nobleBlack.500',
                    background: 'background',
                    backgroundColor: 'background',
                },
            },
            defaultProps: {
                size: 'lg',
                focusBorderColor: 'nobleGreen.500',
            },
        },
        PinInput: {
            defaultProps: {
                size: 'lg',
                focusBorderColor: 'nobleGreen.500',
            },
        },
        NumberInput: {
            baseStyle: {
                field: {
                    borderColor: 'darkGrey',
                    color: 'nobleBlack.500',
                    background: 'background',
                    backgroundColor: 'background',
                },
            },
            defaultProps: {
                size: 'lg',
                focusBorderColor: 'nobleGreen.500',
            },
        },
        Textarea: {
            baseStyle: {
                borderColor: 'darkGrey',
                field: {
                    borderColor: 'darkGrey',
                    color: 'darkGrey',
                    background: 'background',
                    backgroundColor: 'background',
                    paddingTop: '6',
                    paddingBottom: '6',
                },
            },
            defaultProps: {
                focusBorderColor: 'nobleGreen.500',
                borderColor: 'darkGrey',
            },
        },
        Select: {
            baseStyle: {
                field: {
                    borderColor: 'darkGrey',
                    color: 'nobleBlack.500',
                    background: 'background',
                    backgroundColor: 'background',
                },
            },
            defaultProps: {
                size: 'lg',
                focusBorderColor: 'nobleGreen.500',
            },
        },
        FormLabel: {
            baseStyle: {
                fontWeight: '900',
                color: 'darkGrey',
            },
        },
        Checkbox: {
            baseStyle: {
                borderRadius: '9px',
            },
            defaultProps: {
                size: 'lg',
                colorScheme: 'nobleGreen',
            },
        },
        Link: {
            baseStyle: {
                borderRadius: '9px',
            },
        },
        Button: {
            baseStyle: {
                borderRadius: '9px',
                overflow: 'hidden',
                fontWeight: 'semibold',
            },
            defaultProps: {
                size: 'lg',
                overflow: 'hidden',
            },
        },
        CloseButton: {
            baseStyle: {
                _hover: {
                    background: 'gray.100',
                },
            },
        },
        Skeleton: {
            baseStyle: {
                borderRadius: '6px',
            },
        },
    },
    colors: {
        background: '#FDFDFD',
        backgroundGrey: '#EAEAEA',
        white: '#FDFDFD',
        darkGrey: '#545E75',
        lightGrey: '#F5F5F5',
        nobleDarkGray: {
            50: '#EDF2F7',
            100: '#E2E8F0',
            200: '#CBD5E0',
            300: '#A0AEC0',
            400: '#718096',
            500: '#4A5568',
            600: '#2D3748',
            700: '#1A202C',
            800: '#171923',
            900: '#0d1117',
        },
        nobleBlack: {
            50: '#6E7583',
            100: '#303a4e',
            200: '#303a4e',
            300: '#1A202C',
            400: '#1A202C',
            500: '#1A202C',
            600: '#1A202C',
            700: '#050c15',
            800: '#050c15',
            900: '#050c15',
        },
        noblePink: {
            50: '#EEE1F2',
            100: '#EADAEE',
            200: '#E6D3EB',
            300: '#E2CCE8',
            400: '#DEC5E5',
            500: '#DABEE2',
            600: '#D0A8D1',
            700: '#A6809E',
            800: '#443038',
            900: '#443038',
        },
        nobleGreen: {
            50: '#89cccc',
            100: '#c2eded',
            200: '#a0dfdf',
            300: '#7cd2d2',
            400: '#5ac4c4',
            500: '#42abab',
            600: '#318686',
            700: '#205f5f',
            800: '#0d3a3a',
            900: '#001515',
        },
        green: {
            500: '#42abab',
        },
    },
    shadows: {
        outline: '0 0 0 3px rgba(66, 171, 171, 0.6)',
    },
    fonts: {
        body: 'Lato, Noto Sans TC, sans-serif',
        heading: 'Raleway, Noto Sans TC, serif',
    },
    breakpoints: {
        sm: '30em',
        md: '62em',
        lg: '80em',
        xl: '80em',
        '2xl': '96em',
    },
});
